export default __webpack_public_path__ + "static/versa-572e72c1625306739a54938eafd032ad.jpg";